module.exports = __webpack_public_path__ + "x.no1.a9cfd1a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/x.no1.jpg
// module id = 59az
// module chunks = 0